<template>
  <div class="origin-site">
    <div style="margin-top: 24px">
        <CDNRadios
          v-model="closeSelect"
          :items="items1"
          :label="$t('allDomain.tip11')"
          :hasLine="false"
        />
      <div class="row-line" v-show="closeSelect == 1">
        <loginInput
          :label="$t('allDomain.statusCode')"
          tipStyle="color: #A1A7C4;margin-left: -12px;"
          inputStyle="width: 600px;"
          realInputStyle="width: 600px; height: 40px;"
          :inputValue="ipWhiteListItem"
          :bottomTip="$t('allDomain.tip22')"
          @changeInput="(e) => (ipWhiteListItem = e)"
        />
      </div>
    </div>

    <div class="lan-dong" v-show="closeSelect == 1">
      <span class="text-gray-style">{{ $t("allDomain.maintainPage") }}</span>

      <div style="margin-top: 24px">
        <el-input
          type="textarea"
          :rows="5"
          placeholder=""
          v-model="IPBalcktextarea"
        >
        </el-input>
        <div style="margin-bottom: 15px; color: #666666; font-size: 14px">
         {{$t('allDomain.tip33')}}
        </div>
      </div>
    </div>

    <div class="btn-commit" @click="commitClick">
      {{ $t("product.commit") }}
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import { apiHostEdit } from "@/service/requestRes";
export default {
  props: {
    domainHost: String,
    serverJson: String,
  },
  data() {
    return {
      ipWhiteListItem: "",
      IPBalcktextarea: "",
      closeSelect: 0,
      server_json: '',
    };
  },
  computed: {
   items1() {
      return [
        {
          label: this.$t('allDomain.close'),
          value: 0,
        },
        {
          label: this.$t('allDomain.start'),
          value: 1,
        },
      ];
    },
  },

  watch: {
    server_json(val) {
    let serverJson1 = {};
      try {
        let str = '';
        serverJson1 = val && JSON.parse(val);
        console.log(serverJson1);
        const { maintainPage, maintainCode, isMaintain } = serverJson1 || {};
        this.ipWhiteListItem = maintainCode;
        this.IPBalcktextarea = maintainPage;
        this.closeSelect = isMaintain ? 1 : 0; 
      } catch(e) {}
    }
  },
  mounted(){
    this.server_json = this.serverJson;
  },   
  methods: {
    commitClick() {
        if (this.closeSelect==1 && !this.IPBalcktextarea) {
             this.$message({
            message: "维护页面内容不能为空",
            type: "error",
          });
          return;
        }
        const maintain = {
	"func": "maintain",
    "host": this.domainHost,
    "isMaintain": this.closeSelect == 1,
    "maintainCode":this.ipWhiteListItem,
    "maintainPage":	this.IPBalcktextarea,
}

      this.configCNMethod(maintain);
    },

    configCNMethod(obj) {
      apiHostEdit({
        ...obj,
        host: this.domainHost,
      }).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          this.$message({
            message: this.$t('allDomain.tip113'),
            type: "success",
          });
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cenum-setting {
  padding: 21px 0;
  .cenue-title {
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #131523;
  }
  .lan-dong {
    margin-top: 28px;
    .checkbox-content {
      margin-top: 6px;
      display: flex;
      align-items: center;
    }
  }

  .margin-top {
    margin-top: -15px;
  }

  .row-line {
    display: flex;
    align-items: flex-end;
    margin-bottom: 36px;
    .new-add {
      padding: 8px 44px;
      width: 120px;
      height: 40px;
      background: #d9e4ff;
      border-radius: 4px;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #1e5eff;
      cursor: pointer;
      margin-left: 10px;
      margin-bottom: 6px;
    }
  }
  .lan-dong-link {
    display: flex;
    margin-top: 24px;
  }
  .handle-first {
    cursor: pointer;
  }
}

.btn-commit {
  padding: 8px 44px;
  margin: 24px 0px;
  width: 120px;
  background: #d9e4ff;
  border-radius: 4px;
  font-family: PingFangSC-Semibold;
  font-size: 14px;
  color: #1e5eff;
  cursor: pointer;
}
</style>